/*
 * @Author: Yue Hu(yuhu@nvidia.com)
 * @Date: 2024-11-16 11:33:19
 * @LastEditors: Yue Hu(yuhu@nvidia.com)
 * @LastEditTime: 2024-11-25 23:00:17
 * @FilePath: /mooctest.com/src/i18n/i18n.js
 */
import Vue from "vue";
import VueI18n from "vue-i18n";
import locale from "element-ui/lib/locale";
import enLocale from "element-ui/lib/locale/lang/en";
import zhLocale from "element-ui/lib/locale/lang/zh-CN";
import cn from "./langs/cn";
import en from "./langs/en";

Vue.use(VueI18n);
const i18n = new VueI18n({
  locale: localStorage.getItem("lang") || "cn",
  messages: {
    cn: { ...cn, ...zhLocale },
    en: { ...en, ...enLocale },
  },
});
locale.i18n((key, value) => i18n.t(key, value));
// 重新封装方法
export function t(args) {
  return i18n.tc.call(i18n, args);
  // return i18n.tc(key);
}
export default i18n;
